/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
export const insertScrollTop = (top) => {
  const outerContainer = document.getElementById('outer-container');
  outerContainer.style.overflow = 'scroll';
  outerContainer.scrollTo({
    top: window.innerWidth >= 1100 ? 0 : top,
    left: 0,
    behavior: 'smooth',
  });
};
